import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useApiV2ModelContext } from '../../../contexts/ApiV2ModelContext';
import { LoadingMetrics } from './LoadingMetrics';
import { EmptyRange } from './EmptyRange';
import { VelocityReportContent } from './VelocityReportContent';
function getUniquePrs(sprint) {
    return [...new Set([...sprint.merged, ...sprint.review, ...sprint.workInProgress])];
}
export const PullRequestListQuery = ({ activeRepositoriesIds, pullRequestMetrics, repositories, repos, user, from, to, handleRegisterRepo }) => {
    const apiV2ModelContext = useApiV2ModelContext();
    const [loading, setLoading] = useState(true);
    const [pullRequests, setPullRequests] = useState(null);
    const fetchPullRequestList = async () => {
        const currentSprint = pullRequestMetrics[1].sprint;
        const currentUniquePRs = getUniquePrs(currentSprint);
        const results = await apiV2ModelContext.getPullRequestsByIds(currentUniquePRs ?? []);
        setPullRequests(results);
        setLoading(false);
    };
    useEffect(() => {
        const currentSprint = pullRequestMetrics[1].sprint;
        const currentUniquePRs = getUniquePrs(currentSprint);
        const pullRequestsPRs = pullRequests?.pullRequests.map((pr) => pr.id) || [];
        if (pullRequestsPRs !== currentUniquePRs) {
            fetchPullRequestList();
        }
    }, [repos, pullRequestMetrics]);
    if (loading || !pullRequests || !Array.isArray(pullRequests.pullRequests)) {
        return _jsx(LoadingMetrics, {});
    }
    if (pullRequests.pullRequests) {
        const previousSprint = pullRequestMetrics[0].sprint;
        const currentSprint = pullRequestMetrics[1].sprint;
        const currentUniquePRs = getUniquePrs(currentSprint);
        const currentNumberOfPRs = currentUniquePRs.length;
        const previousUniquePRs = getUniquePrs(previousSprint);
        const previousNumberOfPRs = previousUniquePRs.length;
        const currentCycleTime = currentSprint.getCycleTime();
        const previousCycleTime = previousSprint.getCycleTime();
        const datasets = [];
        for (const velocity of pullRequestMetrics[1].daily) {
            datasets.push({
                name: velocity.startDate,
                merge: velocity.mergedAvgTime,
                review: velocity.reviewAvgTime,
                wip: velocity.workInProgressAvgTime,
            });
        }
        return _jsx(VelocityReportContent, { currentNumberOfPRs: currentNumberOfPRs, previousNumberOfPRs: previousNumberOfPRs, currentSprint: currentSprint, currentCycleTime: currentCycleTime, previousCycleTime: previousCycleTime, datasets: datasets, prList: pullRequests, repositories: repositories, user: user, activeRepositoriesIds: activeRepositoriesIds, from: from, to: to, handleRegisterRepo: handleRegisterRepo });
    }
    return _jsx(EmptyRange, {});
};
